import { Handshake, Hub } from '@mui/icons-material'
import * as React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { Trans, useTranslation } from "react-i18next"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"
import railsImage from '../images/rails-logo.svg'
import reactImage from '../images/react-logo.svg'

export const ServicesPage: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "SERVICES" })

  return (
    <Layout title="SERVICES" subtitle={t("SUBTITLE")}>
      <Head title="SERVICES" />
      <div className="my-4">
        <Container className="my-5 py-5">
          <h2 className="mb-5 text-center me-5">
            <Handshake fontSize="medium" className="text-dark" />
            <span className="ms-3 ">{t("SYSTEM_INTEGRATION.TITLE")}</span>
          </h2>
          <div className="mb-5">
            <p>{t("SYSTEM_INTEGRATION.DESC")}</p>
            <h4>{t("SYSTEM_INTEGRATION.STRENGTHS.TITLE")}</h4>
            <ul>
              <li>{t("SYSTEM_INTEGRATION.STRENGTHS.1")}</li>
              <li>{t("SYSTEM_INTEGRATION.STRENGTHS.2")}</li>
              <li>{t("SYSTEM_INTEGRATION.STRENGTHS.3")}</li>
              <li>{t("SYSTEM_INTEGRATION.STRENGTHS.4")}</li>
              <li>{t("SYSTEM_INTEGRATION.STRENGTHS.5")}</li>
            </ul>
            <p>{t("SYSTEM_INTEGRATION.STRENGTHS.DESC")}</p>
            <h4>{t("SYSTEM_INTEGRATION.SERVICE_MENU.TITLE")}</h4>
            <div className="my-2">
              <a href="/rails" style={{ textDecoration: "none" }} className="btn btn-light ">
                <img src={railsImage} alt="Ruby on Rails logo" style={{ width: '100px', height: '40px', marginRight: '3rem' }} />
                {t("SYSTEM_INTEGRATION.SERVICE_MENU.RUBY_ON_RAILS")}
              </a>
            </div>
            <div className="my-2">
              <a href="/react" style={{ textDecoration: "none" }} className="btn btn-light">
                <img src={reactImage} alt="React logo" style={{ width: '100px', height: '40px', marginRight: '3rem' }} />
                {t("SYSTEM_INTEGRATION.SERVICE_MENU.REACT")}
              </a>
            </div>
          </div>
          <Row>
            <Col md={4}>
              <a href="/works" style={{ textDecoration: "none" }}>
                <Button className="rounded-0 btn-success text-light mb-4 w-100">{t("SYSTEM_INTEGRATION.BUTTON_WORKS")}</Button>
              </a>
            </Col>
            <Col md={4}>
              <a href="/#contact" style={{ textDecoration: "none" }}>
                <Button className="rounded-0 btn-success text-light w-100">{t("SYSTEM_INTEGRATION.BUTTON_DOCUMENT_REQUEST")}</Button>
              </a>
            </Col>
          </Row>
        </Container>
        <Container className="my-5 py-5">
          <h2 className="mb-5 text-center me-5">
            <Hub fontSize="medium" className="text-dark" />
            <span className="ms-3">{t("REMOTE_WORK.TITLE")}</span>
          </h2>
          <div>
            <p>{t("REMOTE_WORK.DESC_1")}</p>
            <p>{t("REMOTE_WORK.DESC_2")}</p>
            <h4>{t("REMOTE_WORK.ABOUT_SIP.TITLE")}</h4>
            <ul>
              <li>{t("REMOTE_WORK.ABOUT_SIP.1")}</li>
              <li>{t("REMOTE_WORK.ABOUT_SIP.2")}</li>
              <li>{t("REMOTE_WORK.ABOUT_SIP.3")}</li>
            </ul>
          </div>
          <Row>
            <Col md={4}>
              <a href="/#contact" style={{ textDecoration: "none" }}>
                <Button className="rounded-0 btn-success text-light w-100">{t("REMOTE_WORK.BUTTON_DOCUMENT_REQUEST")}</Button>
              </a>
            </Col>
          </Row>
          <p>
            <small>
              <Trans
                i18nKey="SERVICES.REACT_LOGO_LICENSE_NOTICE"
                components={{
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  l: <a href="https://github.com/facebook/react/blob/main/LICENSE"></a>
                }}
              />
            </small>
          </p>
        </Container>
      </div>
    </Layout>
  )
}